// src/app/pages/customization/components/choose-sizes/choose-sizes.component.ts
import { Component, EventEmitter, Output } from '@angular/core';
import { SizeItem, Material, Part } from 'src/app/model/out-fit';

@Component({
  selector: 'app-choose-sizes',
  templateUrl: './choose-sizes.component.html',
  styleUrls: ['./choose-sizes.component.css'],
})
export class ChooseSizesComponent {
  @Output() sizesSelectionsChange = new EventEmitter<{part: 'sizes', value: SizeItem[]}>();
  @Output() marterialSelectionsChange = new EventEmitter<{part: 'materials', value: Part[]}>();

  activePart: Part | null = null;
  tempSelectedMaterial: Material | null = null;

  // Shown in the fabric-type <select>
  fabricTypes = ['PLANA / WOVEN', 'PUNTO / KNITTED'];

  // Quantities (default 12 each per your current UX)
  sizes: SizeItem[] = [
    { size: '4 Years', count: 12 },
    { size: '6 Years', count: 12 },
    { size: '8 Years', count: 12 },
    { size: '10 Years', count: 12 },
    { size: '12 Years', count: 12 },
    { size: '14 Years', count: 12 },
    { size: '16 Years', count: 12 },
    { size: 'S', count: 12 },
    { size: 'M', count: 12 },
    { size: 'L', count: 12 },
    { size: 'XL', count: 12 },
    { size: 'XXL', count: 12 },
    { size: '3 XL', count: 12 },
    { size: '4 XL', count: 12 },
  ];

  // All available materials (shared library)
  materials: Material[] = [
    { type: 'Woven',   name: 'POLYESTER',           details: '210 g/mq ac coating 100% Polyester',                    image: 'assets/img/customize/m1.png'  },
    { type: 'Woven',   name: 'POLYESTER BONDED',    details: '260 g/mq with fleece',                                  image: 'assets/img/customize/m2.png'  },
    { type: 'Woven',   name: 'POLYESTER',           details: '228 g/mq pvc coating',                                  image: 'assets/img/customize/m3.png'  },
    { type: 'Woven',   name: 'MICROFIBER',          details: '50d 60 g/mq 100% Polyester',                            image: 'assets/img/customize/m4.png'  },
    { type: 'Woven',   name: 'PLOYAMIDE',           details: '210 g/mq pu coating 100% Polymide',                     image: 'assets/img/customize/m5.png'  },
    { type: 'Woven',   name: 'TWILL',               details: '230 g/mq, 100% Polyester',                              image: 'assets/img/customize/m6.png'  },
    { type: 'Woven',   name: 'POLYESTER',           details: '50d g/mq ac coating 100% Polyester',                    image: 'assets/img/customize/m7.png'  },
    { type: 'Woven',   name: 'MICROFIBER',          details: '110 g/mq  100% Polyester plain microfiber',             image: 'assets/img/customize/m8.png'  },
    { type: 'Knitted', name: 'POLYESTER',           details: '160 g/mq Tejido Contraste Camisetas 100% Polyester interlock', image: 'assets/img/customize/m9.png'  },
    { type: 'Knitted', name: 'POLYESTER FLEECE',    details: '230 g/mq  95% Polyester 5% Elastan',                    image: 'assets/img/customize/m10.png' },
    { type: 'Knitted', name: 'JACQUARD',            details: '140 g/mq Striped jacquard',                             image: 'assets/img/customize/m11.png' },
    { type: 'Knitted', name: 'SINGLE JERSEY',       details: '160 g/mq  65% Polyester 35% Cotton',                    image: 'assets/img/customize/m12.png' },
    { type: 'Knitted', name: 'POLYESTER JACQUARD',  details: '100% Polyester jacquard Horizontal Striped',            image: 'assets/img/customize/m13.png' },
    { type: 'Knitted', name: 'FELPA LISA',          details: '230 g/mq  100% Polyester Fleece',                       image: 'assets/img/customize/m14.png' },
    { type: 'Knitted', name: 'POLYESTER',           details: '160 g/mq 94% Polyester 6% Cotton',                      image: 'assets/img/customize/m15.png' },
    { type: 'Knitted', name: 'POLYESTER JACQUARD',  details: '145 g/mq 100% Polyester Diagonal jacquard',             image: 'assets/img/customize/m16.png' },
    { type: 'Knitted', name: 'RUNNING',             details: '160 g/mq 35% Polyester 5% Elastan',                     image: 'assets/img/customize/m17.png' },
    { type: 'Knitted', name: 'FLEECE',              details: '280 g/mq 65% Polyester 35% Cotton',                     image: 'assets/img/customize/m18.png' },
  ];

  // Each part must have fabric type + material
  parts: Part[] = [
    { label: 'Jersey - Front',  selectedFabricType: '', selectedMaterial: null, availableMaterials: [] },
    { label: 'Jersey - Back',   selectedFabricType: '', selectedMaterial: null, availableMaterials: [] },
    { label: 'Jersey - Sleeves',selectedFabricType: '', selectedMaterial: null, availableMaterials: [] },
    { label: 'Jersey - Colar',  selectedFabricType: '', selectedMaterial: null, availableMaterials: [] },
    { label: 'Shorts',          selectedFabricType: '', selectedMaterial: null, availableMaterials: [] },
    { label: 'Socks',           selectedFabricType: '', selectedMaterial: null, availableMaterials: [] },
  ];

  ngOnInit() {
    this.emitSizes();
    this.emitMaterial();
  }

  // ---------- sizes ----------
  increase(s: SizeItem) {
    s.count++;
    this.emitSizes();
  }
  decrease(s: SizeItem) {
    if (s.count > 12) {
      s.count--;
      this.emitSizes();
    }
  }
  emitSizes() {
    this.sizesSelectionsChange.emit({ part: 'sizes', value: this.sizes });
  }

  // ---------- materials ----------
  emitMaterial() {
    this.marterialSelectionsChange.emit({ part: 'materials', value: this.parts });
  }

  getFabricTypeKey(uiType: string): 'Woven' | 'Knitted' | string {
    if (uiType.toUpperCase().includes('WOVEN'))   return 'Woven';
    if (uiType.toUpperCase().includes('KNITTED')) return 'Knitted';
    return uiType;
  }

  chooseFabricType(part: Part, type: string) {
    part.selectedFabricType = type;
    part.selectedMaterial = null; // reset
    const actualType = this.getFabricTypeKey(type);
    part.availableMaterials = this.materials.filter(m => m.type === actualType);
    this.emitMaterial();
  }

  openMaterialModal(part: Part) {
    if (!part.selectedFabricType) return;
    this.activePart = part;
    this.tempSelectedMaterial = part.selectedMaterial;
  }

  selectMaterial(mat: Material) {
    this.tempSelectedMaterial = mat;
  }

  confirmMaterial() {
    if (this.activePart) {
      this.activePart.selectedMaterial = this.tempSelectedMaterial;
      this.activePart = null;
      this.emitMaterial(); // notify parent
    }
  }

  cancelMaterial() {
    this.activePart = null;
  }

  // ids for e2e/tests
  formatId(id: string): string {
    const parts = id.split(/[\s-]+/);
    if (!parts.length) return '';
    const [first, ...rest] = parts;
    return [first.toLowerCase(), ...rest.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())].join('');
  }
}
